import { FaMoon, FaSun } from 'react-icons/fa';
import LogoLight from '../images/vectors/logoLight';
import LogoDark from '../images/vectors/logoDark';


export const lightMode = {
    bgColor: 'hsl(0, 0%, 92%)',
    bgShade: 'hsl(356, 57%, 95%)',
    bgShade2: 'hsl(356, 57%, 90%)',
    bgShade3: 'hsla(356, 57%, 99%, .5)',
    logo: <LogoLight/>,
    icon: <FaMoon/>,
    color01: 'hsl(54, 94%, 49%)',
    color02: 'hsl(35.1, 100%, 49.2%)',
    fgColor: 'hsl(345, 6%, 13%)',
    fgColor2: 'hsl(345, 6%, 40%)',
    fgColor3: 'hsl(345, 6%, 11%)',
    outerShadow: '3px 3px 3px hsl(0, 0%, 82%), -3px -3px 3px hsl(0, 0%, 97%)',
    innerShadow: 'inset 3px 3px 3px hsl(0, 0%, 82%), inset -3px -3px 3px hsl(0, 0%, 97%)',
    EmptyShadow: '0 0 0 hsl(0, 0%, 82%), 0 0 0 hsl(0, 0%, 97%)',
};

export const darkMode = {
    bgColor: 'hsl(264, 6%, 16%)',
    bgShade: 'hsl(264, 6%, 16%)',
    bgShade2: 'hsl(264, 6%, 10%)',
    bgShade3: 'hsla(264, 6%, 13%, .5)',
    logo: <LogoDark/>,
    icon: <FaSun/>,
    color01: 'hsl(46, 37%, 49%)',
    color02: 'hsl(44, 39%, 40%)',
    fgColor: 'hsl(0, 0%, 92%)',
    fgColor2: 'hsl(0, 0%, 88%)',
    fgColor3: 'hsl(0, 0%, 95%)',
    outerShadow: '3px 3px 3px #222327, -3px -3px 3px #363636',
    innerShadow: 'inset 3px 3px 3px #222327, inset -1px -1px 3px #363636',
    EmptyShadow: '0 0 0 #222327, 0 0 0 #363636',
}